import { Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from '../components/layout';
import { TicketingLayout } from '../pages/Workbench/TicketingLayout';
import { MyTicketsView } from '../pages/MyTicketsView/MyTicketsView';
import { AllTicketsView } from '../pages/AllTicketsView';
import { ITTicketCreationPage } from '../pages/TicketCreation';
import { ITTicketViewPage } from '../pages/ITTicketView';
import { UserSubmitTicketPage } from '../pages/UserSubmitTicket';
import { UserHelpCenter } from '../pages/UserHelpCenter';
import { MyRequestsPage } from '../pages/MyRequests';
import { UserTicketView } from '../pages/UserTicketView';
import { AdminView } from '../pages/AdminView/AdminView';
import { KnowledgeBase, ArticleView, ArticleEditor, TemplateSelector } from '../pages/KnowledgeBase';
import { RequireAuth, RequireITStaff, RequireAdmin } from './ProtectedRoute';

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        {/* ============================================ */}
        {/* User Portal Routes */}
        {/* ============================================ */}

        {/* User Help Center - Main landing page for users (public) */}
        <Route path="help" element={<UserHelpCenter />} />

        {/* User's submitted requests (requires auth) */}
        <Route path="my-requests" element={<RequireAuth><MyRequestsPage /></RequireAuth>} />
        <Route path="my-requests/:id" element={<RequireAuth><UserTicketView /></RequireAuth>} />

        {/* Legacy route - redirect to help */}
        <Route path="submit-ticket" element={<RequireAuth><UserSubmitTicketPage /></RequireAuth>} />

        {/* ============================================ */}
        {/* IT Portal Routes (Protected) */}
        {/* ============================================ */}

        {/* Ticketing System (IT Staff) */}
        <Route path="ticketing" element={<RequireITStaff><TicketingLayout /></RequireITStaff>}>
          <Route index element={<Navigate to="my-work" replace />} />
          <Route path="my-work" element={<MyTicketsView />} />
          <Route path="all-tickets" element={<AllTicketsView />} />
          <Route path="ticket/:id" element={<ITTicketViewPage />} />
        </Route>

        {/* Ticket Creation (IT Staff) - Standalone route */}
        <Route path="tickets/new" element={<RequireITStaff><ITTicketCreationPage /></RequireITStaff>} />

        {/* Redirect /tickets to the main ticketing view */}
        <Route path="tickets" element={<Navigate to="/ticketing/all-tickets" replace />} />

        {/* Admin (IT Staff - Admin role required) */}
        <Route path="admin">
          <Route index element={<Navigate to="users" replace />} />
          <Route path="users" element={<RequireAdmin><AdminView /></RequireAdmin>} />
          <Route path="tech-status" element={<RequireAdmin><AdminView /></RequireAdmin>} />
          <Route path="stats" element={<RequireAdmin><AdminView /></RequireAdmin>} />
        </Route>

        {/* ============================================ */}
        {/* Shared Routes (Both Portals) */}
        {/* ============================================ */}

        {/* Knowledge Base - Full management (IT Portal) */}
        <Route path="knowledge-base">
          <Route index element={<Navigate to="articles" replace />} />
          <Route path="articles" element={<KnowledgeBase />} />
          <Route path="article/:id" element={<ArticleView />} />
          {/* Article creation/editing requires IT staff */}
          <Route path="new" element={<RequireITStaff><TemplateSelector /></RequireITStaff>} />
          <Route path="new/:type" element={<RequireITStaff><ArticleEditor /></RequireITStaff>} />
          <Route path="edit/:id" element={<RequireITStaff><ArticleEditor /></RequireITStaff>} />
        </Route>

        {/* Knowledge Base - Shorthand routes (User Portal friendly) */}
        <Route path="kb" element={<KnowledgeBase />} />
        <Route path="kb/:id" element={<ArticleView />} />

        {/* ============================================ */}
        {/* Default Routes */}
        {/* ============================================ */}

        {/* Default redirect - Help Center is the landing page */}
        <Route path="/" element={<Navigate to="/help" replace />} />
        <Route path="*" element={<Navigate to="/help" replace />} />
      </Route>
    </Routes>
  );
}
